import {Routes, Route, Link} from 'react-router-dom';

export default function Booking (){

    return (
        <div id="bookingPage">
            <div className="bgOverlayWhite">
                <div className="row" id="worksHeader">
                    <div className="col-12 col-lg-7 name">
                        <div className="row">
                            <section className="wrapper">
                                {/* <Link to={"/"}> */}
                                <div className="top">BOOKING</div>
                                {/* </Link> */}
                            </section>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 nav">
                        <div className="row">
                            <div className="col-6">
                                <Link to={"/all-works"}><span>WORKS</span></Link>
                            </div>
                            {/* <div className="col-4">
                                <Link to={"/socials"}><span>SOCIALS</span></Link>
                            </div> */}
                            <div className="col-6">
                            <Link to={"/contact"}><span>CONTACT</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="bookingContent">
                    <div className='bookingRow'>
                        <h4>Mixing & Mastering Services</h4>
                        <div id="mixLinks">
                            <a href="https://soundbetter.com/profiles/240812-krzwl-music" rel="noopener noreferrer" target="_blank" title="KRZWL Music profile on SoundBetter" >
                                <img alt="KRZWL Music, Mixing Engineer on SoundBetter" 
                                id="SBlogo"
                                src="https://d2p6ecj15pyavq.cloudfront.net/assets/SoundBetterBadge-c84cb3e75c4267f5bee41f7f617a81d9.svg" 
                                // style="max-width: 130px;" 
                                />
                            </a>
                            <a href="https://engineears.com/jaykurzweil" rel="noopener noreferrer" target="_blank" title="KRZWL Music profile on EngineEars" >
                                <img alt="KRZWL Music, Mixing Engineer on EngineEars" 
                                    id="EElogo"
                                    src={require("./images/EngineEars_Logo_Dark.jpg")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                        </div>
                        <div id="mixLinks">
                            <p>SoundBetter.com</p>
                            <p>EngineEars.com</p>
                        </div>
                    </div>
                    <div className='bookingRow'>
                        <h4>Production Services</h4>
                        {/* <a href="mailto:jaykurzweil@gmail.com">jaykurzweil@gmail.com</a> */}
                        <a href="mailto:jay@krzwlmusic.com" rel="noopener noreferrer" target="_blank" title="" id="bookingEmail">
                                <img alt="" 
                                    id=""
                                    src={require("./images/email.png")}
                                    // style="max-width: 130px;" 
                                />
                            </a>
                            <p>Inquire by Email</p>
                    </div>
                </div>
            </div>
        </div>
    )
}